import React from 'react'
import styles from './styles/no-data-container.module.scss'

interface Props {
  className?: string
}

/**
 *
 *  Container used when no data is available
 *
 */

const NoDataContainer: React.FC<Props> = ({ children, className }) => {
  return (
    <div
      className={`${styles.noDataContainer} ${className} history-line-chart_noDataContainer--override`}
    >
      {children}
    </div>
  )
}

export default NoDataContainer
